
export const styles = theme => ({
  inputDesign: {
    width: '100%',
  },
  inputUnFocused : {
    borderColor: '#e0e0e0 !important'
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  notchedOutline: {},
  inputFocused: {},
  inputWrapper: {
    color: '#253137',
    padding: '14px',
    paddingLeft: '0px',
  },
  cssLabel: {
    width: '100%',
    '&$inputFocused': {
      color: '#f69f21 !important',
    },
  },
  cssOutlinedInput: {
    '&$inputFocused $notchedOutline': {
      borderColor: '#f69f21',
    },
  },
  labelRoot: {
    color: '#778f9b',
    marginLeft: '-5px',
  },
  formLabelRoot: {},
  checkBoxRoot: {
    color: '#f69f21',
    padding: '0px 15px',
    '&$checked': {
      color: '#f69f21',
    },
  },
  checked: {},
  icon: {color: '#253137'},
  
  div: {},
  error: {
    margin: '8px',
    borderRaduis: '5px'
  },
});